import { isRouteErrorResponse, Link, useRouteError } from 'react-router'
import { Button } from '@/components/ui/button'

/** Centralized render-error boundary for every route. */
export function RouteError() {
  const error = useRouteError()
  const isChunkError = error instanceof Error && /Failed to fetch dynamically imported module|Importing a module script failed/i.test(error.message)
  if (!isRouteErrorResponse(error)) console.error('[route-error]', error)
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center px-6 text-center">
      <p className="mb-2 text-xs font-medium tracking-[0.2em] text-primary uppercase">Algo salió mal</p>
      <h1 className="font-display text-3xl">{isChunkError ? 'Hay una nueva versión' : 'No pudimos mostrar esta página'}</h1>
      <p className="mt-3 text-muted-foreground">
        {isChunkError ? 'Recarga la página para continuar con la versión más reciente.' : 'Intenta de nuevo. Si el problema continúa, vuelve al inicio.'}
      </p>
      <div className="mt-6 flex gap-3">
        <Button onClick={() => window.location.reload()}>Recargar</Button>
        <Button asChild variant="secondary">
          <Link to="/">Ir al inicio</Link>
        </Button>
      </div>
    </div>
  )
}
